import { observer } from 'mobx-react';
import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector, { timelineConnectorClasses } from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import AdviceTimelinePageStore from './store/AdviceTimelinePageStore';
import { useLocation } from 'react-router-dom';
import { useRootStore } from 'store/StoreContextProvider';
import EvalHeader from './component/EvalHeader';
import CommentViewModal from './component/CommentViewModal';
import { AssessModel } from 'domains/models/AssessModel';
import { Box, Divider, Grid, CircularProgress, Button } from '@mui/material';
import BasicImage from 'pages/MyPage/component/BasicImage';
import { ListItemText } from '@mui/material';
import bluePin from '../../assets/image/bluePin.png';
import redPin from '../../assets/image/redPin.png';
interface Props {
  pageStore: AdviceTimelinePageStore;
}
function AdviceTimelinePageListView(props: Props) {
  const { pageStore } = props;
  const { headerStore } = useRootStore();

  const location = useLocation();
  const employee = location.state.employee;
  const onHandleClick = (assess: AssessModel) => {
    pageStore.setAssess(assess);
    pageStore.fetchTaskByAssessId(assess.parentId!);
    pageStore.setIsOpenModal(true);
  };

  const handleClickMoredata = () => {
    pageStore.fetchAsssessList(employee);
  };

  React.useEffect(() => {
    headerStore.setPageTitle('Summary');
    pageStore.fetchAsssessList(employee);
  }, []);

  const renderLockIcon = (child: AssessModel) => {
    if (child.subtype === 'VISIBLE') {
      return <LockOpenIcon fontSize='small' />;
    } else {
      return <LockIcon fontSize='small' />;
    }
  };
  const renderPinIcon = (child: AssessModel) => {
    if (child.userData?.like === 'true') {
      return <img src={bluePin} alt='bluePin' />;
    } else if (child.userData?.like === 'false') {
      return <img src={redPin} alt='redPin' />;
    }
  };

  const renderTitle = (assess: AssessModel, task: any) => {
    if (task.subtype === 'CHAT') {
      if (task.userData?.body?.contentType === 'html') {
        let content = task.userData?.body?.content;

        content = content
          ?.split('<')
          .filter((el: any) => !el.startsWith('img'))
          .filter((el: any) => !el.startsWith('div>&nbsp'))
          ?.join('<');

        return (
          <div>
            <div
              style={{
                maxHeight: '49px',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '16px',
                color: '#171918',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              dangerouslySetInnerHTML={{
                __html: content as any,
              }}
            ></div>
          </div>
        );
      } else {
        let content = task.userData?.body?.content?.split('<')[0];
        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '19px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {content}
          </div>
        );
      }
    } else {
      if (task.userData?.bodyPreview) {
        return (
          <div
            style={{
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '16px',
              lineHeight: '22px',
              color: '#171918',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {task.title}
            <div
              style={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '20px',
                color: '#171918',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {task.userData?.bodyPreview}
            </div>
          </div>
        );
      }
      return (
        <div
          style={{
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '19px',
            color: '#171918',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {task.title}
        </div>
      );
    }
  };

  return (
    <>
      <Grid container alignItems={'center'} style={{ marginTop: '40px' }}>
        <Grid xs={12} sm={4} md={3} style={{ paddingLeft: '20px' }}>
          <Box sx={{ display: 'flex' }}>
            {pageStore.employee?.userData?.profile ? (
              <BasicImage
                src={pageStore.employee.userData?.profile}
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  overflow: 'hidden',
                }}
              />
            ) : (
              <Avatar style={{ width: 60, height: 60 }}>
                <ImageIcon
                  sx={{
                    borderRadius: '50%',
                    objectFit: 'cover',
                    overflow: 'hidden',
                  }}
                />
              </Avatar>
            )}
            <ListItemText
              primary={
                <span
                  style={{
                    fontFamily: 'Pretendard',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: '16px',
                    color: '#000000',
                  }}
                >
                  {pageStore.employee?.userData.deptName}
                </span>
              }
              secondary={
                <span
                  style={{
                    fontFamily: 'Pretendard',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '14px',
                    color: '#212121',
                  }}
                >
                  {pageStore.employee?.names?.fullname}
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '12px',
                      color: '#6C6B6F',
                      marginLeft: '4px',
                    }}
                  >
                    {pageStore.employee?.userData.jobTitle}
                  </span>
                </span>
              }
              style={{
                margin: 0,
                marginLeft: '16px',
              }}
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={8} md={9}>
          <EvalHeader pageStore={props.pageStore} />
        </Grid>
      </Grid>

      <Divider
        style={{
          border: '0.5px solid #eeeeee',
          width: '100%',
          marginTop: '26px',
        }}
      />
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
          [`& .${timelineConnectorClasses.root}`]: {
            background: '#E5E5E5',
          },
        }}
      >
        {pageStore.isLoading ? (
          <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
            <CircularProgress />
          </Grid>
        ) : (
          pageStore.assessList &&
          pageStore.assessList.map((assess: AssessModel) => {
            return (
              <TimelineItem key={assess.id} style={{ cursor: 'pointer' }} onClick={() => onHandleClick(assess)}>
                <TimelineSeparator>
                  <TimelineDot
                    style={{
                      width: '44px',
                      height: '44px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      background: assess.userData?.emoticon ? '#47D4FF55' : '#47D4FF11',
                      border: '1px solid #47D4FF',
                      boxShadow: 'none',
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    {assess.userData?.emoticon || ''}
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: '12px', px: 2, maxWidth: '600px' }}>
                  <Grid container alignItems={'center'} justifyContent={'space-between'}>
                    <Grid>
                      <Typography
                        style={{
                          fontStyle: 'normal',
                          fontWeight: 400,
                          fontSize: '12px',
                          lineHeight: '12px',
                          marginBottom: '6px',
                        }}
                      >
                        {moment(assess.created).format('YYYY년 MM월 DD일')}
                      </Typography>
                    </Grid>
                    <Grid></Grid>
                    <Grid container justifyContent='right' alignItems='right' style={{ width: 120, textAlign: 'right' }}>
                      <Grid item justifyContent={'center'}>
                        {assess.subtype === 'INVISIBLE' || assess.subtype === 'VISIBLE' ? (
                          <span
                            style={{
                              verticalAlign: 'top',
                              marginTop: '4px',
                              display: 'inline-block',
                              fontWeight: 500,
                              fontSize: '14px',
                              lineHeight: '14px',
                            }}
                          >
                            {assess.userData.grade}점
                          </span>
                        ) : (
                          ''
                        )}
                      </Grid>
                      <Grid item justifyContent={'center'} alignItems={'center'}>
                        {renderLockIcon(assess)}
                        {renderPinIcon(assess)}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    style={{
                      border: '1px solid #006DCE55',
                      marginTop: '5px',
                      marginBottom: '10px',
                      borderRadius: '15px',

                      padding: '18px 20px',
                    }}
                  >
                    <Grid
                      style={{
                        fontWeight: 500,
                        fontSize: '14px',
                        lineHeight: '16px',
                        width: 'calc(100vw - 150px)',
                        maxWidth: '500px',

                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {assess.parents && renderTitle(assess, assess.parents)}
                    </Grid>
                    <Grid
                      style={{
                        fontWeight: 400,
                        fontSize: '13px',
                        lineHeight: '17px',
                        marginTop: '4px',
                        width: 'calc(100vw - 150px)',
                        maxWidth: '500px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {assess.title}
                    </Grid>
                  </Grid>
                </TimelineContent>
              </TimelineItem>
            );
          })
        )}
      </Timeline>

      <CommentViewModal pageStore={pageStore} />
    </>
  );
}

export default observer(AdviceTimelinePageListView);
